import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  container: {
    padding: theme.spacing(3),
    minHeight: '100vh',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing(3),
  },
  title: {
    fontSize: 24,
    fontWeight: 700,
    color: '#1F2937',
  },
  breadcrumb: {
    display: 'flex',
    alignItems: 'center',
    gap: 4,
    marginBottom: theme.spacing(2),
    flexWrap: 'wrap' as const,
  },
  breadcrumbItem: {
    cursor: 'pointer',
    color: '#3B82F6',
    fontWeight: 500,
    fontSize: 14,
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  breadcrumbSeparator: {
    color: '#9CA3AF',
    margin: '0 4px',
    fontSize: 14,
  },
  breadcrumbCurrent: {
    color: '#6B7280',
    fontWeight: 500,
    fontSize: 14,
  },
  entryRow: {
    display: 'flex',
    alignItems: 'center',
    padding: '10px 16px',
    cursor: 'pointer',
    borderRadius: 8,
    marginBottom: 4,
    '&:hover': {
      backgroundColor: '#F3F4F6',
    },
  },
  entryIcon: {
    marginRight: 12,
    color: '#6B7280',
    fontSize: 20,
  },
  entryName: {
    flex: 1,
    fontWeight: 500,
    color: '#1F2937',
    fontSize: 14,
  },
  entryDate: {
    color: '#9CA3AF',
    fontSize: 12,
  },
  fileViewer: {
    marginTop: theme.spacing(2),
  },
  preContent: {
    backgroundColor: '#1F2937',
    color: '#E5E7EB',
    fontFamily: 'monospace',
    fontSize: 13,
    padding: theme.spacing(2),
    borderRadius: 8,
    maxHeight: 600,
    overflowY: 'auto' as const,
    whiteSpace: 'pre-wrap' as const,
    wordBreak: 'break-word' as const,
  },
  jsonContent: {
    backgroundColor: '#1F2937',
    color: '#A5F3FC',
    fontFamily: 'monospace',
    fontSize: 13,
    padding: theme.spacing(2),
    borderRadius: 8,
    maxHeight: 600,
    overflowY: 'auto' as const,
    whiteSpace: 'pre-wrap' as const,
    wordBreak: 'break-word' as const,
  },
  htmlFrame: {
    width: '100%',
    minHeight: 500,
    border: '1px solid #E5E7EB',
    borderRadius: 8,
    backgroundColor: '#fff',
  },
  emptyState: {
    textAlign: 'center' as const,
    padding: theme.spacing(6),
    color: '#9CA3AF',
  },
  backButton: {
    marginBottom: theme.spacing(2),
    textTransform: 'none' as const,
    borderRadius: 8,
    fontWeight: 600,
  },
}));
